export const getSyncIndicatorState = ({ isOnline, isSyncing, pendingChanges, error }, t) => {
  const hasOfflineChanges = pendingChanges > 0;

  if (error) {
    return { status: 'failed', text: t('sync.failed') };
  }
  if (!isOnline) {
    return {
      status: 'offline',
      text: hasOfflineChanges
        ? t('sync.offlineWithChanges', { count: pendingChanges })
        : t('sync.offline'),
    };
  }
  if (isSyncing) {
    return { status: 'syncing', text: t('sync.syncing') };
  }
  if (hasOfflineChanges) {
    return {
      status: 'syncing',
      text: t('sync.pendingChanges', { count: pendingChanges }),
    };
  }
  return { status: 'synced', text: t('sync.synced') };
};
